<div class="shimmer-loader">
  <div class="bar"></div>
  <div class="bar"></div>
  <div class="bar"></div>
</div>
